/* Kkumi — public guest order tracking. POSTs order number + checkout email to
 * the rate-limited /apps/rewards/track endpoint and renders the shared
 * tracking card. Wrong email and unknown order are the same "no match". */
(function () {
  'use strict';

  /** Minimal refund block derived from the status chip alone. */
  function refundFromChip(chip) {
    if (chip !== 'refunded' && chip !== 'cancelled') return null;
    return {
      state: chip === 'cancelled' ? 'cancelled' : 'refunded',
      cancelled: chip === 'cancelled',
      amount_cents: null, currency: null, at: null, cancel_reason: null, note: null,
    };
  }

  function init(root) {
    var A = window.KKAcct;
    var d8 = root.dataset;
    var el = A.el;
    var form = root.querySelector('[data-kka-track-form]');
    var result = root.querySelector('[data-kka-track-result]');

    function renderFound(b) {
      var grid = el('div', 'kka-grid');
      var strip = el('div', 'kka-track__strip');
      var orderLabel = d8.copyOrderLabel || 'Order';
      var itemSingular = d8.copyItemSingular || 'item';
      var itemPlural = d8.copyItemPlural || 'items';
      var no = el('span', 'kka-track__strip-no', orderLabel + ' ');
      no.appendChild(el('em', null, b.order.name));
      strip.appendChild(no);
      strip.appendChild(el('span', 'kka-track__strip-meta',
        A.fmtDate(b.order.created_at) + ' · ' + b.order.item_count +
        ' ' + (b.order.item_count === 1 ? itemSingular : itemPlural) +
        (b.order.total_cents != null ? ' · ' + A.money(b.order.total_cents, b.order.currency) : '')));
      grid.appendChild(strip);

      var card = el('section', 'kka-card');
      var head = el('div', 'kka-card__head');
      head.appendChild(el('h2', 'kka-card__title', d8.copyTrackingTitle));
      head.appendChild(A.chip(b.order.status_chip));
      card.appendChild(head);

      // Money-back state leads, because a refunded or cancelled order has no
      // delivery to look forward to — rendering the cheery voice line and the
      // 4-step tracker over the top of one reads as "still coming".
      //
      // `refund` comes from the worker, but the status chip has always carried
      // the same fact, so fall back to it: a theme deployed ahead of the worker
      // (or an older worker generally) must still refuse to draw the stepper
      // over a refunded order. The fallback knows no amount or reason, which
      // refundNotice() handles with its amount-unknown copy.
      var refund = b.refund || refundFromChip(b.order.status_chip);
      var settled = !!refund && refund.state !== 'partially_refunded';
      if (refund) card.appendChild(A.refundNotice(refund, { helpUrl: d8.urlHelp }));

      if (b.tracking) {
        // A settled order keeps its scan history (the pack may well have
        // shipped before the refund) but loses the stepper and voice line.
        card.appendChild(settled
          ? A.trackingEvents(b.tracking)
          : A.trackingBody(b.tracking, { helpUrl: d8.urlHelp }));
      } else if (!settled) {
        var voice = el('div', 'kka-voice');
        var voiceLine = el('p', 'kka-voice__line');
        if (window.KKIcons) {
          voiceLine.appendChild(window.KKIcons.el('sparkles', 'kka-voice__icon'));
          voiceLine.appendChild(document.createTextNode(' '));
        }
        voiceLine.appendChild(document.createTextNode(A.voiceFor(null)));
        voice.appendChild(voiceLine);
        card.appendChild(voice);
        card.appendChild(A.stepper({ stage: 'ordered' }));
      }
      grid.appendChild(card);
      result.replaceChildren(grid);
    }

    function renderNotFound() {
      var card = el('div', 'kka-card');
      card.appendChild(A.emptyState({
        icon: 'box', title: d8.copyNotfoundTitle, pop: 'found', copy: d8.copyNotfound,
      }));
      var again = el('button', 'button button--secondary button--small', d8.copyNotfoundCta);
      again.type = 'button';
      again.style.cssText = 'display:block;margin:0 auto 10px;';
      again.addEventListener('click', function () {
        result.replaceChildren();
        form.querySelector('[name="order_number"]').focus();
      });
      card.appendChild(again);
      result.replaceChildren(card);
    }

    // Theme editor: nobody can complete a real lookup inside the preview
    // iframe, so render a refunded sample result — that's the state with the
    // most copy behind it (refund notice, reason line, help link) and the
    // merchant needs to see it move as they edit.
    if (A.designMode) {
      renderFound({
        order: {
          name: '#1011', created_at: new Date().toISOString(),
          status_chip: 'refunded', item_count: 3, total_cents: 0, currency: 'AUD',
        },
        tracking: null,
        refund: {
          state: 'refunded', cancelled: true, amount_cents: 8900, currency: 'AUD',
          at: new Date().toISOString(), cancel_reason: 'inventory', note: null,
        },
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var orderNumber = form.querySelector('[name="order_number"]').value.trim();
      var email = form.querySelector('[name="email"]').value.trim();
      if (!orderNumber || !email) return;
      // Content-shaped skeleton mirroring the found result: order strip + a
      // card with head, voice bar and the 4-step tracking stepper.
      var skGrid = el('div', 'kka-grid');
      var skStrip = el('div', 'kka-track__strip');
      skStrip.appendChild(A.skel(180, 18));
      skStrip.appendChild(A.skel(220, 11));
      skGrid.appendChild(skStrip);
      var skCard = el('section', 'kka-card');
      var skHead = el('div', 'kka-card__head');
      skHead.appendChild(A.skel(110, 13));
      var skChip = A.skel(80, 20, 999); skChip.style.marginLeft = 'auto'; skHead.appendChild(skChip);
      skCard.appendChild(skHead);
      var skVoice = A.skel('100%', 46, 12); skVoice.style.margin = '4px 0 20px'; skCard.appendChild(skVoice);
      skCard.appendChild(A.skelStepper());
      skGrid.appendChild(skCard);
      result.replaceChildren(skGrid);
      A.fetchProxy('/track', { method: 'POST', body: { order_number: orderNumber, email: email } })
        .then(renderFound)
        .catch(function (err) {
          if (err.status === 404 || err.status === 400) return renderNotFound();
          if (err.status === 429) {
            var card = el('div', 'kka-card');
            card.appendChild(el('p', 'kka-error__copy', d8.copyLimit));
            card.style.textAlign = 'center';
            result.replaceChildren(card);
            return;
          }
          var errCard = el('div', 'kka-card');
          errCard.appendChild(A.errorState(d8.copyErrorNoun || 'tracking', function () { form.requestSubmit(); }));
          result.replaceChildren(errCard);
        });
    });

    // Handed over from the contact page's quick track form: fill both fields
    // and run the lookup at once. sessionStorage rather than the URL so the
    // email never lands in history, analytics or referrers; one-shot, 5 min.
    var pre = null;
    try {
      pre = JSON.parse(window.sessionStorage.getItem('kk-track-prefill') || 'null');
      window.sessionStorage.removeItem('kk-track-prefill');
    } catch (e) { pre = null; }
    if (pre && pre.order && pre.email && Date.now() - (pre.at || 0) < 5 * 60 * 1000) {
      form.querySelector('[name="order_number"]').value = pre.order;
      form.querySelector('[name="email"]').value = pre.email;
      if (form.requestSubmit) form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { cancelable: true }));
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-kka-track]').forEach(function (root) {
      if (root.dataset.kkBound) return;
      root.dataset.kkBound = '1';
      init(root);
    });
  });
})();
